import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createCharge, createSubscription } from '../../../actions';
import { STRIPE_PUBLISHABLE } from '../../../constants';
import BigButton from '../../../components/BigButton';

class StripeCheckoutButton extends React.Component {

  state = {clicked: false};

  checkoutHandler = window.StripeCheckout.configure({
    key: STRIPE_PUBLISHABLE,
    locale: "auto"
  });

  componentWillReceiveProps(nextProps) {
    if (nextProps.isCustomerSynced) {
      this.setState({clicked: false})
    }
  }

  render() {

    let onToken;

    const {
      id,
      name,
      currency,
      priceInCents,
      billedMonthly,
      description
    } = this.props.plan;

    // Stripe token handler
    if (billedMonthly) {
      onToken = stripeToken => this.props.createSubscription(
        this.props.accessToken,
        stripeToken,
        id,
        this.props.customer.id
      )
    } else {
      onToken = stripeToken => this.props.createCharge(
        this.props.accessToken,
        stripeToken,
        id,
        this.props.customer.id,
        description,
        priceInCents,
        currency
      );
    }

    const onButtonClick = () => {
      this.setState({clicked: true});
      if (this.checkoutHandler) {
        this.checkoutHandler.open({
          name: name,
          description: description,
          token: onToken
        })
      }
    };

    return (
      <BigButton
        onClick={onButtonClick}
        loading={this.state.clicked && !this.props.isCustomerSynced}
        text={billedMonthly ? 'SUBSCRIBE' : 'BUY'}
        icon={null}
      />
    );
  }
}


function mapStateToProps(state) {
  return {
    customer: state.customer,
    accessToken: state.accessToken,
    isCustomerSynced: state.isCustomerSynced
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createCharge,
    createSubscription
  }, dispatch)
}


StripeCheckoutButton = connect(
  mapStateToProps,
  mapDispatchToProps
)(StripeCheckoutButton);

StripeCheckoutButton.PropTypes = {
  plan: PropTypes.object.isRequired
};

export default StripeCheckoutButton;



// WEBPACK FOOTER //
// ./src/containers/Buttons/StripeButton/index.js